// Cells of the mail transfer logs table (see mailTransferLogsHeader)

export const TRANSFER_STATUS_LABELS = {
  sent: "Delivered",
  deferred: "Deferred",
  bounced: "Bounced",
  blocked: "Blocked",
  "not delivered": "Not delivered",
};

export const formatTransferTime = (value) => {
  const date = new Date(value);
  if (!value || isNaN(date)) return "-";
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export const TransferTimeCell = ({ value }) => (
  <span className="mgw-transfer__time">{formatTransferTime(value)}</span>
);

export const TransferStatusCell = ({ value }) => {
  const status = value || "unknown";
  return (
    <span className={`mgw-transfer__status mgw-transfer__status--${status.replace(/\s+/g, "-")}`}>
      {TRANSFER_STATUS_LABELS[status] || status}
    </span>
  );
};

export const TransferTextCell = ({ value }) => (
  <span className="mgw-transfer__text" title={value || ""}>
    {value || "-"}
  </span>
);

// Next hop as postfix logs it, host[ip]:port, shown as "host (ip)"; "timeout" means nothing was tried
export const TransferRelayCell = ({ value }) => {
  if (!value || value === "timeout") return "-";
  const match = value.match(/^([^[]+)\[([^\]]+)\](?::(\d+))?$/);
  if (!match) return <TransferTextCell value={value} />;
  return (
    <span className="mgw-transfer__text" title={value}>
      {match[1]} ({match[2]})
    </span>
  );
};

export const TransferDelayCell = ({ value }) => {
  const seconds = parseFloat(value);
  if (isNaN(seconds)) return "-";
  return `${seconds < 10 ? seconds.toFixed(2) : Math.round(seconds)} s`;
};
